import styled from 'styled-components';

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(${({ $columns = 2 }) => Number($columns) || 2}, minmax(0, 1fr));
    gap: ${({ $gap = '12px' }) => $gap};
`;

export const FormGridItemFull = styled.div`
    grid-column: 1 / -1;
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 6px;
    margin-bottom: 10px;
`;
